import {initStylizedYandexMap} from '../../elements/div.infrastructure-map/index';

// const onChangeFilters = (map) => {
// 	const filters  = map.querySelectorAll( 'button.filter' );

// 	if ( !filters.length )
// 	{
// 		return;
// 	}

// 	map.addEventListener( 'click', ( {target} ) => {
// 		if ( target.closest( 'button.filter' ) )
// 		{
// 			filters.forEach( ( filter ) => filter.classList.remove( 'active' ) );

// 			target.closest( 'button.filter' ).classList.add( 'active' );
// 		}
// 	} )
// }

const initStylizedMap = () => {
	const components = document.querySelectorAll( 'section.stylized-map' );

	if ( !components.length )
	{
		return;
	}

	components.forEach( ( component ) => {
		// onChangeFilters( component );
		
		initStylizedYandexMap( component )
	} )
}

export {
	initStylizedMap,
}
